<div class="bulk-download-container">
  <div class="loader-overlay" *ngIf="isDownloading">
    <div class="loader-content">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="loader-text">Generating PDFs, please wait...</p>
      <p class="loader-subtext">This may take a few moments</p>
    </div>
  </div>

  <div class="row" style="margin-bottom: 20px;">
    <div class="col-xs-12 col-md-3 form-group filterByDuration pad0" style="display: grid">
      <label for="pahafStatus">FILTER BY PAHAF STATUS</label>
      <div class="filter-by-pahaf-status">
        <angular2-multiselect 
          [data]="pahafStatusOptions" 
          [(ngModel)]="selectedPahafStatus"
          class="multiselect-dropdown-style form-control input-underline no-border" 
          [settings]="dropdownSettings" 
          (onSelect)="onPahafStatusSelect($event)" 
          (onDeSelect)="onPahafStatusDeSelect($event)"
          (onSelectAll)="onPahafStatusSelectAll($event)" 
          (onDeSelectAll)="onPahafStatusDeSelectAll($event)">
        </angular2-multiselect>
      </div>
    </div>

    <div class="col-xs-12 col-md-3 form-group filterByDuration pad0" style="display: grid">
      <label for="refreshStatus">FILTER BY REFRESH STATUS</label>
      <div class="filter-by-pahaf-status">
        <angular2-multiselect 
          [data]="refreshStatusOptions" 
          [(ngModel)]="selectedRefreshStatus"
          class="multiselect-dropdown-style form-control input-underline no-border" 
          [settings]="dropdownSettings" 
          [disabled]="isSecondDropdownDisabled"
          [class.disabled-dropdown]="isSecondDropdownDisabled"
          (onSelect)="onRefreshStatusSelect($event)" 
          (onDeSelect)="onRefreshStatusDeSelect($event)"
          (onSelectAll)="onRefreshStatusSelectAll($event)" 
          (onDeSelectAll)="onRefreshStatusDeSelectAll($event)">
        </angular2-multiselect>
      </div>
    </div>


    <div class="col-xs-12 col-md-3 form-group filterByDuration pad0" style="display: grid">
      <label for="pahafStatus">FILTER BY PCP</label>
      <div class="filter-by-pcp">
        <angular2-multiselect 
          [data]="pcpOptions" 
          [(ngModel)]="selectedPcp"
          class="multiselect-dropdown-style form-control input-underline no-border" 
          [settings]="dropdownSettings" 
          (onSelect)="onPCPSelect($event)" 
          (onDeSelect)="onPCPDeSelect($event)"
          (onSelectAll)="onPCPSelectAll($event)" 
          (onDeSelectAll)="onPCPDeSelectAll($event)">
        </angular2-multiselect>
      </div>
    </div>

    <div class="col-xs-12 col-md-3 form-group" style="display: flex; align-items: flex-end;">
      <button 
        type="button"
        class="btn btn-secondary" style="margin: 5px;"
        (click)="clearFilters()">
        Clear Filters
      </button>
    </div>

  </div>

  <div class="selection-info" *ngIf="getSelectedCount() > 0" style="margin-bottom: 15px; padding: 10px; background: #e7f3ff; border-left: 4px solid #2196f3; border-radius: 4px; display: flex; justify-content: space-between; align-items: center;">
    <span style="font-weight: 600; color: #1976d2;">{{ getSelectedCount() }} item(s) selected</span>
    <button 
      type="button"
      class="btn btn-primary"
      (click)="downloadSelectedPDFs()"
      [disabled]="isDownloading">
      <i class="fa fa-download" style="margin-right: 5px;"></i>
      {{ isDownloading ? 'Downloading...' : 'Download Selected PDFs' }}
    </button>
  </div>

  <div class="memberContainer dashboard-content">
    <table class="table custom-table myTable" id="bulkDownloadTable">
      <thead>
        <tr class="table-header">
          <th class="checkBoxContainer" style="width: 5em">
            <input 
              type="checkbox"
              (change)="toggleAllRows()"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
          </th>
          <th>PCP</th>
          <th>MEMBER ID</th>
          <th>MEMBER NAME</th>
          <th>DATE OF BIRTH</th>
          <th>PAHAF STATUS</th>
          <th>REFRESH STATUS</th>
        </tr>
      </thead>
      <tbody class="panels">
        <tr *ngFor="let row of getCurrentPageData()" 
            class="rows"
            [class.selected-row]="selection.isSelected(row)"
            [class.downloaded-row]="isRowDownloaded(row)">
          <td class="checkBoxContainer">
            <input 
              type="checkbox"
              (click)="$event.stopPropagation()"
              (change)="selection.toggle(row)"
              [checked]="selection.isSelected(row)">
          </td>
          <td>{{ row.pcpName || 'N/A' }}</td>
          <td>{{ row.memberHmoID || 'N/A' }}</td>
          <td>{{ row.memberFirstName || 'N/A' }}</td>
          <td>{{ row.memberDOB || 'N/A' }}</td>
          <td [ngClass]="getStatusClass(row.status)" style="text-align: left;">{{ row.status || 'N/A' }}</td>
          <td>{{ row.refreshStatus || 'N/A' }}</td>
        </tr>
        <tr *ngIf="dataSource.filteredData.length === 0">
          <td colspan="7" style="text-align: center; padding: 40px; color: #999;">
            No data available
          </td>
        </tr>
      </tbody>
    </table>

    <mat-paginator 
      [pageSizeOptions]="[10, 25, 50, 100]"
      [pageSize]="10"
      showFirstLastButtons
      aria-label="Select page of members">
    </mat-paginator>
  </div>
</div>
